import React, { useEffect } from "react";
import { ServerPlanInterface } from "src/store/mine_craft/serverPlansSlice";
import { HEX_COLOR } from "./format";

import Swatch from "./_Swatch";
import { Button, Form, Input, InputNumber, Select, Switch } from "antd";

const MAX_PLAYERS = 200;

interface propsInterface {
  params?: ServerPlanInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();
  const primary_color = Form.useWatch('primary_color', form);
  const tint_color    = Form.useWatch('tint_color', form);

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='app_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <Form.Item label="Published" name='published' valuePropName='checked'>
        <Switch />
      </Form.Item>

      <Form.Item label="Featured (BEST VALUE)" name='featured' valuePropName='checked'>
        <Switch />
      </Form.Item>

      <h6 className='v-content-label o-sm'>PLAN</h6>

      <Form.Item name='title' label="Title" rules={[{ required: true }]}>
        <Input placeholder='City' />
      </Form.Item>

      <Form.Item
        name='slug'
        label="Slug"
        extra='Stable identifier, unique per app: a-z, 0-9, - and _'
        rules={[{ required: true }]}
      >
        <Input placeholder='city' />
      </Form.Item>

      <Form.Item name='description' label="Description">
        <Input.TextArea rows={3} placeholder='High performance for a low price.' />
      </Form.Item>

      <Form.Item name='coins' label="Price (coins)">
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>

      <h6 className='v-content-label o-sm'>RESOURCES</h6>

      <Form.Item name='memory_mb' label="Memory (MB)" rules={[{ required: true }]}>
        <InputNumber min={256} max={32768} style={{ width: '100%' }} placeholder='2048' />
      </Form.Item>

      <Form.Item name='disk_mb' label="Storage (MB)" rules={[{ required: true }]}>
        <InputNumber min={512} max={204800} style={{ width: '100%' }} placeholder='15360' />
      </Form.Item>

      <Form.Item
        name='cpu_percent'
        label="CPU (%)"
        extra='1 vCPU = 100%'
        rules={[{ required: true }]}
      >
        <InputNumber min={25} max={800} style={{ width: '100%' }} placeholder='100' />
      </Form.Item>

      <Form.Item
        name='max_players'
        label="Player slots"
        extra={`Hard cap: ${MAX_PLAYERS} — what the top tier sells instead of "unlimited".`}
        rules={[{ required: true }]}
      >
        <InputNumber min={1} max={MAX_PLAYERS} style={{ width: '100%' }} placeholder='25' />
      </Form.Item>

      <h6 className='v-content-label o-sm'>PRESENTATION</h6>

      <Form.Item
        name='primary_color'
        label="Primary color"
        extra='Accent on the plan card: title, price and checkmarks. Leave empty for the app default.'
        rules={[{ pattern: HEX_COLOR, message: 'Must be a hex color, e.g. #7C4DFF' }]}
      >
        <Input placeholder='#7C4DFF' addonAfter={<Swatch color={primary_color} />} />
      </Form.Item>

      <Form.Item
        name='tint_color'
        label="Tint color"
        extra='Background wash behind the card. Leave empty for the app default.'
        rules={[{ pattern: HEX_COLOR, message: 'Must be a hex color, e.g. #F3EDFF' }]}
      >
        <Input placeholder='#F3EDFF' addonAfter={<Swatch color={tint_color} />} />
      </Form.Item>

      <Form.Item
        name='features'
        label="Extra features"
        extra='Additional bullet lines on the pricing card. Ordering of the plans themselves is set from the sidebar.'
      >
        <Select mode='tags' tokenSeparators={[',']} placeholder='Add a feature' />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
